import * as CryptoJS from 'crypto-js'

const decrypt = (ciphertext: string, secretKey: string, withError = false) => {
  try {
    const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey)
    const originalData = bytes.toString(CryptoJS.enc.Utf8)

    // Check if the result is empty or not valid UTF-8
    if (!originalData) {
      throw new Error('Decryption failed: Empty result')
    }

    return originalData
  } catch (error) {
    if (withError) {
      throw error
    }
    return '' // or return null, or throw the error based on your needs
  }
}

export default decrypt
